import { render, staticRenderFns } from "./EmbeddedWhatsapp.vue?vue&type=template&id=3c45aa5a"
import script from "./EmbeddedWhatsapp.vue?vue&type=script&lang=js"
export * from "./EmbeddedWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports